'use client';
import { useStore } from '@/store/store';
import { getPlatformBridge } from '@/logic/bridges';
import './styles/mohegansun.scss';
import { useGlobalContext } from '@/store/contexts/global-context';

export const LoyaltyPopup = () => {
    const { activePopup, closePopup } = useStore((state) => state.popup);
    const { isIosWrapper } = useGlobalContext();
    const { message } = activePopup!;

    const handleClose = () => {
        if (isIosWrapper) {
            getPlatformBridge().exec('closeWebView');
        }
        closePopup();
    };

    return (
        <div className="loyalty-popup">
            <header className="loyalty-popup__header">
                <div className="loyalty-popup__close-btn" onClick={handleClose} />
            </header>
            <section className="loyalty-popup__content">
                <div>{message}</div>
                <button className="loyalty-popup__cta" onClick={handleClose}>
                    Got it
                </button>
            </section>
        </div>
    );
};
